import { DateTime } from "luxon";

export class BaseFirestoreData {
  updatedAt: DateTime;
  createdAt: DateTime;
  deletedAt: DateTime | null;
}

export class BaseFirestorePath {
  name?: string;
  path: string;
  param: typeof PathParam;
  class: typeof BaseFirestoreData;
  isCollection?: boolean;
  isPrivate?: boolean;
}

export class PathParam {
  __dummy?: string;
}
